export const APP_ID = 'nmuc7nrk'
